import { SITE_URL } from '../routes'
import { en } from '../i18n/en'

/** Props of {@link PageMeta}. */
export interface PageMetaProps {
  /** Page title, before `· t.armx`; the site name alone when absent. */
  title?: string
  /** `<meta name="description">`, for search results. */
  description?: string
  /** Path of the page, for its canonical link. Without it, the page is `noindex`. */
  canonicalPath?: string
}

/**
 * Title, description and indexing of the current page. React 19 moves these
 * elements into `<head>`.
 */
export function PageMeta({ title, description = en.site.description, canonicalPath }: PageMetaProps) {
  return (
    <>
      <title>{title ? `${title} · ${en.site.name}` : en.site.name}</title>
      <meta name="description" content={description} />
      {canonicalPath === undefined ? (
        <meta name="robots" content="noindex" />
      ) : (
        <link rel="canonical" href={`${SITE_URL}${canonicalPath}`} />
      )}
    </>
  )
}
